import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("[client-sort] connected", this.element)
  }

  sort(event) {
    event.preventDefault()
    console.log("[client-sort] sort clicked", event.currentTarget)

    const field = event.currentTarget.dataset.sortField
    const direction = event.currentTarget.dataset.sortDirection || "asc"
    console.log("[client-sort] field/direction", field, direction)

    const container = document.getElementById("fundraisers")
    console.log("[client-sort] container", container)
    if (!container) return

    const items = Array.from(container.children)

    const readValue = (el) => {
      const raw = el.dataset[field]
      const num = Number(raw)
      return Number.isNaN(num) ? (raw || "").toString() : num
    }

    items.sort((a, b) => {
      const av = readValue(a)
      const bv = readValue(b)

      let cmp = 0
      if (typeof av === "number" && typeof bv === "number") {
        cmp = av - bv
      } else {
        cmp = av.localeCompare(bv)
      }

      return direction === "desc" ? -cmp : cmp
    })

    items.forEach(item => container.appendChild(item))
  }
}